export type AssistantItem = {
  id: string; projectId: number; projectNumber: string; title: string;
  kind: 'task' | 'attachments'; state: string; messageId?: string;
  sourceSubject: string; sourceUrl?: string; receivedAt: string; fromEmail: string;
};

export function groupAssistantItems<T extends AssistantItem>(items: T[]) {
  const groups = new Map<string, T[]>();
  for (const item of items.filter(i => i.state !== 'dismissed')) {
    // Prefer the original message identity. Never merge different projects.
    const source = item.messageId || item.sourceUrl || item.id;
    const key = JSON.stringify([item.projectId, source]);
    groups.set(key, [...(groups.get(key) || []), item]);
  }
  return [...groups.values()];
}

export function assistantTone(items: AssistantItem[]) {
  if (items.some(i => ['unknown', 'failed', 'conflict'].includes(i.state))) return { color: 'red', label: 'Check outcome' };
  if (items.some(i => i.state === 'suggested' && i.kind === 'task' && !isGenericCorrespondence(i))) return { color: 'amber', label: 'Review decision' };
  if (items.every(i => ['completed', 'duplicate'].includes(i.state))) return { color: 'green', label: 'Processed' };
  return { color: 'blue', label: 'Mail update' };
}

export function isGenericCorrespondence(item: AssistantItem) {
  return item.kind === 'task' && /^Review project correspondence:/i.test(item.title);
}

export function actionableAssistantItems<T extends AssistantItem>(items: T[]) {
  return items.filter(i => ['unknown', 'executing'].includes(i.state) || i.kind === 'task' && !isGenericCorrespondence(i));
}

/** A request without a named work object must not become an engineering conclusion. */
export function isUnscopedMailRequest(item: { title: string; concreteAction?: boolean }) {
  return item.concreteAction === false || /^(?:please\s+)?(?:check|review|see|look at)\s+(?:(?:the|my|an?)\s+)?(?:(?:attached|following)\s+)?(?:screenshot|attachments?|images?|photos?|this|it|above|below)(?:\s+(?:attached|please))?[.!?]*$/i.test(item.title.trim()) || /^(?:please\s+)?(?:see|check|review)\s+attached[.!?]*$/i.test(item.title.trim());
}
